export default "__VITE_ASSET__794e9bc5__"